module.exports = __webpack_public_path__ + "img/shang3.1ddbd8a1.png";